<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		
		<div class="">
			<el-form inline ref="form" :model="searchform">
       
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      start-placeholder="시작"
						      end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">검색</el-button>	
					</el-form-item>
			</el-form>
       
		
		</div>
	
	</div>
   

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       
       empty-text="데이타가 없습니다">
 
      <el-table-column
        
        label="날짜" prop="io_type" align="center" width="100">

      </el-table-column>
       <el-table-column
        label="부본사 슬롯" prop="io_id" align="center" width="100">
        
      </el-table-column> 

      <el-table-column
        label="부본사 바카라" prop="io_in_name" align="center">
        
      </el-table-column> 


       <el-table-column
        
        label="부본사 슬롯+바카라" prop="io_money" align="center">
        <template slot-scope="scope"><span class="text-danger">{{ formatMoney(scope.row.io_money)}}</span></template>

      </el-table-column>

      <el-table-column
        
        label="총판 슬롯" prop="io_out_money" align="center">
        <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.io_out_money)}}</span></template>

      </el-table-column>
     
        <el-table-column
        
        label="총판 바카라" prop="io_jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.io_jan)}}</template>

      </el-table-column>

      <el-table-column
        
        label="총판 슬롯+바카라" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
      
     <el-table-column
        
        label="매장 슬롯" prop="io_regdate" align="center">
      </el-table-column>
		
		 <el-table-column
        
        label="매장 바카라" prop="sip" align="center">
      </el-table-column>
       <el-table-column
        
        label="매장 슬롯+바카라" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
       <el-table-column
        
        label="회원 슬롯" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
       <el-table-column
        
        label="회원 바카라" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
       <el-table-column
        
        label="회원 슬롯+바카라" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
       <el-table-column
        
        label="총처리롤링금" prop="mem_cash" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>

      </el-table-column>
      
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
        <!-- Model -->
  
				
</div>
 </template>

 <script>
 
    export default {
    
    	data(){
    		return{
        
          domain:window.sessionStorage.getItem('domain'),

    			searchform:{
    				time:[],

    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
        valueOption:'아이디',
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			         superSearch:false,
               gubun:'',
			         
			 
    			}
    			
    			
    		},
        
    		created() {
        

    			this.getList();
    			
			
		},
    	
    	methods:{

   
        
    			 // 搜索事件
			searchEvent(){

    			this.getList();
    			
             this.currentPage=1;

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		   

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/moneylist?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     //console.log('data=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.total_cash = response.data.total_cash
                     this.total_ecash = response.data.total_ecash
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    	
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/views/rollingstat/list.vue